<template>
  <div>
    <AdoptPage/>
  </div>
</template>

<script>
import AdoptPage from "./components/AdoptPage.vue"
export default {
  name: 'App',
  components: {
    AdoptPage,
  },
  data() {
    return {}
  },
}
</script>

<style>
</style>
